module["exports"] = [
  "г-ѓа",
  "г-ца",
  "д-р",
  "м-р",
];
